import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';

function ResignModal({ isOpen, onClose, onConfirm, user, loading }) {
  const [resignDate, setResignDate] = useState('');

  useEffect(() => {
    if (isOpen) {
      // Set default to today's date
      const today = new Date().toISOString().split('T')[0];
      setResignDate(today);
    }
  }, [isOpen]);

  function handleSubmit(e) {
    e.preventDefault();
    onConfirm(resignDate);
  }

  if (!user) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Resign User" size="sm">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <p className="text-gray-700 mb-4">
            Are you sure you want to mark <span className="font-semibold">{user.nickname}</span> as resigned?
          </p>

          <div>
            <label className="label">
              Resign Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              value={resignDate}
              onChange={(e) => setResignDate(e.target.value)}
              className="input"
              max={new Date().toISOString().split('T')[0]} // Can't select future dates
              required
            />
            <p className="text-xs text-gray-500 mt-1">
              This user will no longer be able to login after being marked as resigned.
            </p>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-200">
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="outline-danger"
            loading={loading}
          >
            Mark as Resigned
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export default ResignModal;
